// From Templates
import { load } from '@shopify/theme-sections';

import './index.js';
import './product.js';
import './cart.js';
import './collection.js';
import './campaigns.js';
// TODO: Check if this is being used on the gift template
// import './gift_card.js';

document.addEventListener('DOMContentLoaded', () => {
  load('*');
});

console.log('📐 Template components: Loaded');
